// import { Message } from "./Message";
import { Message } from "./Mesaage";

export const MessageThread = () => (
  <section className="flex flex-col gap-6 items-start w-full">
    <Message
      author="Orlando Diggs"
      time="Thursday 10:16am"
      content="Thanks everyone! Almost there."
      image="https://cdn.builder.io/api/v1/image/assets/TEMP/114aeaaf906cc8c29176911dba5dfac33baae989"
      isOutgoing={false}
    />
    <Message
      author="Demi Wilkinson"
      time="Thursday 11:44am"
      content="Good timing — was just looking at this."
      image="https://cdn.builder.io/api/v1/image/assets/TEMP/06b6c5f3045dc625f3d5a1e0122791bc4def10fd"
      isOutgoing={false}
    />
  </section>
);
